<template>
  <div class="content login">
    <div class="columns is-centered">
      <div class="column is-6" v-if="isInitialized">
        <form @submit.prevent="submit" v-if="isValid">
          <h1>Welcome To WRIOS!</h1>
          <p>Please set a password to finish registration</p>
          <div class="field">
            <label class="label">Email</label>
            <div class="control">
              <input class="input" required v-model="email.options.email" type="email" disabled>
            </div>
          </div>
          <div class="field">
            <label class="label">Password</label>
            <div class="control">
              <input class="input" required v-model="email.password" type="password">
            </div>
          </div>

          <div class="field">
            <label class="label">Confirm Password</label>
            <div class="control">
              <input class="input" required v-model="email.password_confirmation" type="password">
            </div>
          </div>

          <hr>
          <button type="submit" class="button is-primary">Set Password</button>
        </form>
        <div v-else>
          <h1>INVITATION EXPIRED</h1>
          <p>
            This invitation is no longer valid.
            <br>Click below to request a new invitation.
          </p>
          <p>
            <router-link :to="{name: 'request-password-reset'}">Request New Invitation</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordsApi from '@/services/api/Passwords'

export default {
  props: {
    email: Object
  },
  data() {
    return {
      isValid: false,
      isInitialized: false
    }
  },

  created() {
    console.log(this.email.options)
    this.validateToken(this.email.options.token)
  },

  methods: {
    validateToken(token) {
      let self = this

      PasswordsApi.findToken(token)
        .then(resp => {
          self.token = resp.data.token
          self.isInitialized = true
          self.isValid = true
        })
        .catch(err => {
          console.log(err)
          self.isInitialized = true
        })
    },

    submit() {
      let self = this

      PasswordsApi.resetPassword(this.email.options.token, this.email.options.email, this.email.password, this.email.password_confirmation)
        .then(resp => {
          self.$store.commit('success', 'Password set successfully')
          self.$router.push({ name: 'login' })
        })
        .catch(err => {
          if (this.email.password !== this.email.password_confirmation) {
            self.$store.commit('error', 'Please ensure your password confirmation matches')
          } else {
            self.$store.commit('error', err.response.data.message)
          }
        })
    }
  }
}
</script>
